import { useState } from 'react'

const useGeolocation = (): {
  getLocation: () => Promise<{
    isSuccess: boolean
    error?: string
    coordinates: {
      latitude: number
      longitude: number
    }
  }>
  isLoadingLocation: boolean
} => {
  const [isLoadingLocation, setIsLoadingLocation] = useState<boolean>(false)

  // CDMX Location
  const defaultLocation = {
    longitude: -99.1394,
    latitude: 19.2769
  }

  const getLocation = async (): Promise<{
    isSuccess: boolean
    error?: string
    coordinates: {
      latitude: number
      longitude: number
    }
  }> => {
    setIsLoadingLocation(true)
    return new Promise((resolve) => {
      if (!navigator?.geolocation) {
        setIsLoadingLocation(false)
        resolve({
          isSuccess: false,
          error: 'Geolocation is not supported by your browser',
          coordinates: defaultLocation
        })
      }

      navigator.geolocation.getCurrentPosition(
        (location) => {
          const { latitude, longitude } = location.coords

          setIsLoadingLocation(false)
          resolve({
            isSuccess: true,
            coordinates: {
              latitude,
              longitude
            }
          })
        },
        () => {
          setIsLoadingLocation(false)
          resolve({
            isSuccess: false,
            error: 'Unable to retrieve your location',
            coordinates: defaultLocation
          })
        }
      )
    })
  }

  return {
    getLocation,
    isLoadingLocation
  }
}

export default useGeolocation
